import type { RefObject } from "react";
import { Box } from "@mui/material";
import SponsorDetail from "../../sponsors/Sponsor";
import type { Deal } from "../../../types/deal";

type DealSponsorsTabProps = {
  sponsorsRef: RefObject<HTMLDivElement | null>;
  deal: Deal;
};

export function DealSponsorsTab({ sponsorsRef, deal }: DealSponsorsTabProps) {
  return (
    <Box ref={sponsorsRef} sx={{ mt: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(1, 1fr)",
          gap: 2,
        }}
      >
        {typeof deal.sponsor === "object" &&
          deal.sponsor &&
          (deal.sponsor as { id?: number }).id && (
            <SponsorDetail
              sponsorId={(deal.sponsor as { id: number }).id}
              isEdit={false}
              borrowers={deal.sponsor_borrowers}
            />
          )}
        {typeof deal.secondary_sponsor === "object" &&
          deal.secondary_sponsor &&
          (deal.secondary_sponsor as { id?: number }).id && (
            <SponsorDetail
              sponsorId={(deal.secondary_sponsor as { id: number }).id}
              isEdit={false}
              borrowers={deal.secondary_sponsor_borrowers}
            />
          )}
      </Box>
    </Box>
  );
}
